(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;
      this.isAtTop = false;

      this.suppressScrollUntil = 0;
      this.toggleBtn = this.querySelector('header-menu-toggle');
      this.toggleBtn?.addEventListener('click', () => {
        this.suppressScrollUntil = performance.now() + 250;
        this.header.classList.toggle('shopify-section-header-menu-open');
      });

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.disconnectedCallback?.();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (performance.now() < this.suppressScrollUntil) {
        this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return;
      }

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop <= 0) {
        this.header.classList.remove('shopify-section-header-sticky');
        document.body.classList.remove('shopify-body-section-header-sticky');
        this.isAtTop = true;
        this.currentScrollTop = scrollTop;
        return;
      }
      if (this.isAtTop && scrollTop > 10) {
        this.isAtTop = false;
      }
      if (this.isAtTop) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hg-collaborate"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.querySelector('[data-hgc-contact]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';
  const key = 'hg-collaboration-contact-draft-v1';
  const clear = () => { try { sessionStorage.removeItem(key); } catch (_) {} };
  const success = root.querySelector('[data-hgc-sent]');
  if (success) { clear(); success.focus(); return; }
  const form = root.querySelector('form');
  if (!form) return;
  const fields = Array.from(form.querySelectorAll('input:not([type="hidden"]),textarea,select')).filter(el => el.name.startsWith('contact['));
  const status = root.querySelector('[data-native-status]');
  const error = root.querySelector('[data-client-error]');
  try {
    const draft = JSON.parse(sessionStorage.getItem(key) || 'null');
    if (draft && Date.now() - draft.time < 7200000) {
      fields.forEach(el => { if (!el.value && typeof draft.values[el.name] === 'string') el.value = draft.values[el.name]; });
    } else { clear(); }
  } catch (_) { clear(); }
  const save = () => {
    try { sessionStorage.setItem(key, JSON.stringify({time:Date.now(),values:Object.fromEntries(fields.map(el => [el.name,el.value]))})); } catch (_) {}
  };
  form.addEventListener('input', save);
  form.addEventListener('change', save);
  form.addEventListener('submit', event => {
    save();
    if (!navigator.onLine) { event.preventDefault(); error.hidden=false; error.focus(); return; }
    error.hidden=true;
    form.setAttribute('aria-busy','true');
    status.textContent=status.dataset.sending;
  });
  window.addEventListener('pageshow', () => { form.removeAttribute('aria-busy'); status.textContent=''; });
  const serverError = root.querySelector('[data-server-errors]');
  if (serverError) serverError.focus();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hg-social"] && !Shopify.designMode) return;
  try {
    
function initHGS(root) {
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const key = 'hg_preferred_cafe_v1';
  const links = [...root.querySelectorAll('[data-cafe]')];
  const saved = root.querySelector('[data-saved-cafe]');
  const chooser = root.querySelector('[data-cafe-chooser]');
  const savedLink = root.querySelector('[data-saved-link]');
  let preference;
  try { preference = JSON.parse(localStorage.getItem(key)); } catch {}
  const match = preference && preference.expires > Date.now() && links.find(a => a.dataset.cafe === preference.id);
  if (match) {
    savedLink.href = match.href;
    savedLink.innerHTML = match.innerHTML;
    savedLink.dataset.cafe = match.dataset.cafe;
    savedLink.dataset.event = 'cafe_order_clicked';
    saved.hidden = false; chooser.hidden = true;
    root.querySelector('[data-remember]').checked = true;
  }
  root.querySelector('[data-change]').addEventListener('click', () => { chooser.hidden = false; saved.hidden = true; links[0].focus(); });
  root.querySelector('[data-forget]').addEventListener('click', () => {
    try { localStorage.removeItem(key); } catch {}
    chooser.hidden = false; saved.hidden = true; root.querySelector('[data-remember]').checked = false; links[0].focus();
  });
  root.querySelector('[data-remember]').addEventListener('change', event => { if (!event.target.checked) { try { localStorage.removeItem(key); } catch {} } });
  root.addEventListener('click', event => {
    const a = event.target.closest('a');
    if (!a) return;
    if (a.dataset.cafe && root.querySelector('[data-remember]').checked) {
      try { localStorage.setItem(key, JSON.stringify({id:a.dataset.cafe, expires:Date.now()+90*86400000})); } catch {}
    }
    if (a.dataset.event && window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true) {
      try { window.Shopify.analytics?.publish('hg_social_' + a.dataset.event, {page_version:'social_v1',cafe_id:a.dataset.cafe || '',product_handle:a.dataset.product || '',gift_type:a.dataset.kind || '',platform:a.dataset.device || ''}); } catch {}
    }
  });
  const ua = navigator.userAgent;
  const platform = /Android/i.test(ua) ? 'android' : /iPhone|iPad|iPod/i.test(ua) ? 'ios' : '';
  if (platform) { const preferred = root.querySelector('[data-device="'+platform+'"]'); preferred.dataset.preferred='true'; preferred.parentNode.prepend(preferred); }
}
document.querySelectorAll('[data-hg-social]').forEach(initHGS);
document.addEventListener('shopify:section:load', event => initHGS(event.target.querySelector('[data-hg-social]')));

  } catch(e) { console.error(e); }
})();
})();
